export default ({ request }) => ({
  sysDepartmentListApi(data = {}) {
    return request({
      url: '/sys/department/list',
      method: 'post',
      data,
    })
  },
  sysDepartmentDetailApi(data = {}) {
    return request({
      url: '/sys/department/detail',
      method: 'post',
      data,
    })
  },
  sysDepartmentSaveApi(data = {}) {
    return request({
      url: '/sys/department/save',
      method: 'post',
      data,
    })
  },
  sysDepartmentDelApi(data = {}) {
    return request({
      url: '/sys/department/del',
      method: 'post',
      data,
    })
  },
  sysDepartmentUpdateLevelApi(data = {}) {
    return request({
      url: '/sys/department/updateLevel',
      method: 'post',
      data,
    })
  },
  sysDepartmentListByChooseApi(data = {}) {
    return request({
      url: '/sys/department/listByChoose',
      method: 'post',
      data,
    })
  },
})
